export const EventTypeConstants = {
  FETCH_EVENT_TYPES_REQUEST: "FETCH_GLOBAL_EVENT_TYPES_REQUEST",
  FETCH_EVENT_TYPES_SUCCESS: "FETCH_GLOBAL_EVENT_TYPES_SUCCESS",
  FETCH_EVENT_TYPES_FAILURE: "FETCH_GLOBAL_EVENT_TYPES_FAILURE",
};
